module.exports = __webpack_public_path__ + "static/img/40019 (2).dd6b24a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40019 (2).webp
// module id = wEA7
// module chunks = 14